document.addEventListener('reset_url', (e) => {

	history.replaceState({}, "", '/');

});


